// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user[data-v-f4c97a9a] {\n  padding: 5px;\n  height: 100%;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  flex: 1;\n  background-color: white;\n}\n.user__body[data-v-f4c97a9a] {\n  overflow: auto;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
